export default __webpack_public_path__ + "static/media/035-online payment.21832d60.svg";